<template lang="pug">
  adv-master(
    v-if="bannerPropById.id"
    class="banner-container"
    :bannerProp="bannerPropById"
    :env="env"
    :systemCode="systemCode"
    @onEvent="handleAdvEvent"
  )
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { AdvMaster } from '@hb/h5-components-new';
import { getSystemCode } from '@/utils/systemCode';
import config from '@/const/config';
import { FULI_MODULE_NAV } from '../consts';

export default {
  components: {
    AdvMaster,
  },
  props: {
    bannerById: {
      type: String,
      default: '',
    },
    moduleData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      env: config.env,
      systemCode: null,
    };
  },
  computed: {
    bannerPropById() {
      // 优先使用直接传入的 bannerById，兼容旧版用法
      // 其次从 moduleData 中提取 bannerId（bounty-tab 场景）
      const id = this.bannerById || this.moduleData?.adUnitId || '';

      return {
        id,
        customClick: false,
        style: {
          borderRadius: 12,
        },
      };
    },
  },
  created() {
    // 为当前组件实例配置 UBT，使 AdvMaster 组件能够正常工作
    if (!this.$H5CMP) {
      this.$H5CMP = {};
    }
    this.$H5CMP.UBT = UBT;
    if (getSystemCode) {
      this.systemCode = getSystemCode().toString();
    }
  },
  methods: {
    handleAdvEvent(event = {}) {
      const { type, data } = event;
      if (type === 'onLoad' && data && !data.needShow) {
        this.$emit('hideTab', FULI_MODULE_NAV.alipay_welfare_banner);
      }
    },
  },
};
</script>
<style scoped lang="less">
  .banner-container {
    display: block !important;

    /deep/ .wrapper {
      display: block;
    }
  }
</style>
